// extracted by mini-css-extract-plugin
export default {"topic":"Topic_topic__aw93V"};